import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';
import { logRender } from '../utils/debugLoop';

const LanguageContext = createContext({
  language: 'English',
  setLanguage: (lang: string) => {},
});

export function useLanguage() {
  return useContext(LanguageContext);
}

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');

  logRender('LanguageProvider', undefined, { language });

  const handleLanguageChange = useCallback((lang: string) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  }, []);

  // 🐛 FIX: Memoize the context value to prevent unnecessary re-renders
  const value = useMemo(() => ({ language, setLanguage: handleLanguageChange }), [language, handleLanguageChange]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
} 